import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router'
import {ResolverUtilService} from '../../../core/resolver/resolver-util.service'
import {Observable, of, zip} from 'rxjs'
import {catchError, concatMap, map, take} from 'rxjs/operators'
import {TranslocoService} from '@ngneat/transloco'
import {IndustryOverviewPage} from '../../../core/content/types/industry-overview-page.types'
import {IndustryOverviewPageContentService} from '../../../core/content/services/industry-overview-page-content.service'

export type IndustryOverviewPageResolved = IndustryOverviewPage

@Injectable()
export class IndustryOverviewPageResolver {
  constructor(
    private readonly contentService: IndustryOverviewPageContentService,
    private readonly util: ResolverUtilService,
    private readonly translocoService: TranslocoService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IndustryOverviewPageResolved> {
    const slug = route.paramMap.get('pageSlug')
    if (!slug) {
      return this.util.redirectToNotFound(state.url)
    }

    return this.getContent(slug).pipe(
      take(1),
      concatMap(page => {
        return zip(
          of(page),
          this.translocoService.selectTranslate('offeringSection.jobRequestCallToAction'),
          this.translocoService.selectTranslate('offeringSection.offeringDetailPageCallToAction'),
          of([]),
        )
      }),
      map(([page, requestCta, offeringPageCta, profiles]) => {
        page.offeringsSection?.items.forEach(item => {
          switch (item.targetType) {
            case 'job-request':
              item.description = requestCta
              break
            default:
              item.description = offeringPageCta
              break
          }
        })

        return {...page, profiles}
      }),
      catchError(e => this.util.handleError(e, state.url)),
    )
  }

  private getContent(pageSlug: string): Observable<IndustryOverviewPage> {
    return this.contentService.getIndustryOverviewPage(pageSlug)
  }
}
